import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	查询音视频通话1.0总览信息
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] 描述缺失
 * @param {string} [data.cid] 描述缺失
 */

export function funcnetcalloverview(data: DataModel, options: IRequestOptionsWithPass): Promise<any>
export function funcnetcalloverview(
	data: DataModel,
	options?: IRequestOptions,
): Promise<any extends { msg: unknown } ? any['msg'] : undefined>
export function funcnetcalloverview(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/app/func/netcall/overview', {
		method: 'post',
		params: {
			aid,
			cid,
		},

		...(options || {}),
	})
}
